export const NAME = 'myebons';

export const REQUEST_ACCOUNT_EBONS = 'REQUEST_ACCOUNT_EBONS';
export const RECEIVE_ACCOUNT_EBONS = 'RECEIVE_ACCOUNT_EBONS';
export const FAILURE_ACCOUNT_EBONS = 'FAILURE_ACCOUNT_EBONS';

export const REQUEST_ACCOUNT_EBONS_CODE = 'REQUEST_ACCOUNT_EBONS_CODE';
export const RECEIVE_ACCOUNT_EBONS_CODE = 'RECEIVE_ACCOUNT_EBONS_CODE';
export const FAILURE_ACCOUNT_EBONS_CODE = 'FAILURE_ACCOUNT_EBONS_CODE';



// WEBPACK FOOTER //
// ./src/services/account/ebons/constants.js